import {useEffect, useLayoutEffect, useState} from "react";
import {CreateEmployeeContractor} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi";
import {Contractor} from "../../../../../models/Contractor";
import {toast} from "react-toastify";
import {GetAllServiceType} from "../../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {getPhotoPicker} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg, isEmailFormat, isPhoneFormat} from '../../../../../Apis/functions';
import routes from "../../../../../Routes/routes";
import {STEPS_CONTRACTOR_CREATE, TABS_CONTRACTORS} from "../../Model/Models";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const EmployeeFlowContractorCreateApp =({
       t,
       dispatch,
       navigate,
       workShiftsList,
       customizedList,
       setEmptyFields,
       setIsValidEmail,
       isValidPassword, 
       setIsValidPassword,
       setIsValidPhoneNumber,
       isValidDob,
       photoPicker,
       setPhotoPicker,
       permission,
       setWorkShiftsList,
       setCustomizedList,
       setSecretModal,
       setSecretKey,
       setGeneratedPassword,
       passwordGenerator,
       setSteps
    })=>{

    const [getAllServiceType, setGetAllServiceType] = useState([])
    const [user, setUser] = useState({...Contractor});

    useEffect(()=>{
        dispatch(GetAllServiceType()).then(({payload:{data:{data}}})=>{
            setGetAllServiceType(data)
        });
    },[dispatch])


    useLayoutEffect(() => {
        setSteps([t("company_details"), t("manager_details"), t("add_photo"), t("access_right"), t("summary")]);
    }, [permission, t]);

    //  reset function
    const resetForm = (step) => {
        if(step === STEPS_CONTRACTOR_CREATE.COMPANY_DETAILS){
            setUser({...user.clearCompanyDetails()});
        }
        if(step === STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS){
            setUser({...user.clearManagerDetails()});
        }
        if(step === STEPS_CONTRACTOR_CREATE.ACCESS_RIGHT){
            setWorkShiftsList([]);
            setCustomizedList([]);
        }
        setEmptyFields(false);
    };

    // Form handeler Function
    const FormHandler = () => {
        const emailOk = isEmailFormat(user.email);
        const phoneOk = isPhoneFormat(user.phoneNumber);

        if (!user.isValid() ||
            !isValidDob ||
            !isValidPassword ||
            !phoneOk ||
            !emailOk
        ) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true)
            setIsValidEmail(emailOk);
            setIsValidPhoneNumber(phoneOk);
        } else {
            setEmptyFields(false);
            createContractor();
        }
    };

    const createContractor = () => {
        const customs = customizedList
            .filter((element) => element.added === true && element.new === true)
            .map(({ zoneId, zoneName, dayId, from, to }) => ({
                zoneId: zoneId,
                zoneName: zoneName,
                dayId: dayId,
                from: from,
                to: to,
            }));

        let imageFile = getPhotoPicker(photoPicker);
        const addPw = user?.password?.trim() !== '' && user?.password !== null;
        const password = addPw ? user.password : passwordGenerator();
        const requestData = {
            data: {
                ...user.toCreateUpdate(password),
                workShifts: workShiftsList,
                customs: customs,
            },
            file: imageFile,
        };

        dispatch(CreateEmployeeContractor(requestData)).then(({payload:{data:{success, code, data}}}) => {
            if (success) {
                setSecretModal(true);
                setSecretKey(data?.secret);
                setGeneratedPassword(addPw ? null : password );
                toast.success(t('has_been_created_successfully'));
                setEmptyFields(false);
            }else{
                errorMsg(code)
            }
        });
    }

    const handleValidateSteps = (step) => {
        switch (step) {
            case STEPS_CONTRACTOR_CREATE.COMPANY_DETAILS: {
                if (!user.isValidCompanyDetails()){
                    setEmptyFields(true);
                    return false;
                }
                setEmptyFields(false);
                return true;
            }
            case STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS: {
                const emailOk = isEmailFormat(user.email);
                const phoneOk = isPhoneFormat(user.phoneNumber);

                if (!user.isValidManagerDetails() ||
                    !isValidDob ||
                    !phoneOk ||
                    !emailOk ||
                    !isValidPassword
                ){
                    setIsValidEmail(emailOk);
                    setIsValidPhoneNumber(phoneOk);
                    setEmptyFields(true);
                    return false;
                }
                setEmptyFields(false);
                return true;
            }
            default:
                return true;
        }
    }

    const handleOnBack = () => {
        navigate(routes.contractor.list, {
            state: {currentTab:TABS_CONTRACTORS.CONTRACTORS.INDEX}
        });
    }

    return {
        user,
        setUser,
        FormHandler,
        resetForm,
        getAllServiceType,
        handleValidateSteps,
        handleOnBack
    };
}
